import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  ReactiveFormsModule,
  Validator,
} from '@angular/forms';
import { Icon } from '@shared/components/icon/icon.enum';
import { OpenAnswer } from '@shared/models/question-types/open-answer';
import { OpenAnswerValidationComponent } from '../open-answer-validation/open-answer-validation.component';

@Component({
  selector: 'app-open-answer-input',
  imports: [
    CommonModule,
    OpenAnswerValidationComponent,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: './open-answer-input.component.html',
  styleUrl: './open-answer-input.component.scss',
})
export class OpenAnswerInputComponent
  implements ControlValueAccessor, Validator
{
  @Input({ required: true }) control!: any;
  @Input({ required: true }) question!: OpenAnswer;
  @Input() title: string = '';
  @Input() customClass?: string; // New input for custom CSS classes
  @Input() hideError = false;
  Icon = Icon;

  newRegex(inputString: string) {
    return RegExp(inputString, 'u');
  }

  onChange = (value: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    if (value) {
      this.control.setValue(value);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.control?.disable();
    } else {
      this.control?.enable();
    }
  }

  validate() {
    return this.control.errors;
  }

  // Mark as touched on blur
  onBlur() {
    this.onTouched();
    this.control.markAsTouched();
  }

  // Scroll textarea into view on focus (mobile keyboard fix)
  onFocus(event: FocusEvent) {
    const target = event.target as HTMLElement;
    // Delay to ensure keyboard is shown first
    setTimeout(() => {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });
    }, 300);
  }
}
